
import { leftsideChats} from "../../models/model";
import { RecentChatActions } from "../interface/reducerType";

import {Types} from '../action/action';

const initialState=  {
  recentContact:[
  ],
  pinnedContact:[],
  isRecentchatLoader:false,
  isPinchatLoader:false,
  isUnreadLoader:false,
  isArchiveLoader: false,
  isSavedLoader:false,
  unreadContact:[],
  archiveContact:[],
  draftContact:[],
  savedContact:[],
  recentPageLoad:false,
  unReadPageLoad:false,
  isrecentPageLoad:0,
  isUnreadPageLoad:0,
  unArchivePageLoad:false,
  isArchivePageLoad:0,
  savedPageLoad:false,
  isSavedPageLoad:0,
  isRecentPaginationStop:true,
  isUnreadPaginationStop:true,
  isSavedPaginationStop:true,
  isArchivePaginationStop:true,
  failedContact:[]
};


export const recentchatReducer = (state: leftsideChats = initialState, action: RecentChatActions) => {
  switch (action.type) {

  case Types.SET_RECENT_CHAT:
    return {
      ...state, isRecentchatLoader: true, recentContact: action.payload.recentContact
    };
  case Types.RECENT_LOAD:
    return {
      ...state,  isRecentPaginationStop:action.payload.isRecentPaginationStop,
      recentPageLoad: action.payload.recentPageLoad, isrecentPageLoad: action.payload.isrecentPageLoad
    };
  case Types.UNREAD_LOAD:
    return {
      ...state,isUnreadPaginationStop: action.payload.isUnreadPaginationStop,
      unReadPageLoad: action.payload.unReadPageLoad, isUnreadPageLoad: action.payload.isUnreadPageLoad
    };
  case Types.ARCHIVE_LOAD:
    return {
      ...state, isArchivePaginationStop:action.payload.isArchivePaginationStop,
      unArchivePageLoad: action.payload.unArchivePageLoad,
      isArchivePageLoad: action.payload.isArchivePageLoad
    };
  case Types.SAVED_LOAD:
    return {
      ...state, isSavedPaginationStop:action.payload.isSavedPaginationStop,
      savedPageLoad: action.payload.savedPageLoad,
      isSavedPageLoad: action.payload.isSavedPageLoad
    };
  case Types.SET_UNREAD_CHAT:
    return {
      ...state, isUnreadLoader: true, unreadContact: action.payload.unreadContact
    };
  case Types.SET_ARCHIVE_CHAT:
    return {
      ...state, isArchiveLoader: true, archiveContact: action.payload.archiveContact
    };
  case Types.SET_SAVED_CHAT:
    return {
      ...state, isSavedLoader: true, savedContact: action.payload.savedContact
    };
  case Types.SET_PINNED_CHAT:
    return {
      ...state, isPinchatLoader:true, pinnedContact: action.payload.pinnedContact
    };
  case Types.SAVE_DRAFT_MESSAGE:
    return {
      ...state, draftContact: action.payload.draftContact
    };
  case Types.FAILED_CONTACT:
      return {
        ...state, failedContact: action.payload.failedContact
      };
  default:
    return state;
  }
};